export const descricaoNiveis: Record<number, string> = {
  1: "Periodo de proprietario (PEU) com datas exatas e mesmo tipo de interesse da procura.",
  2: "Periodo de proprietario com datas aproximadas e mesmo tipo de interesse.",
  3: "Periodo de proprietario com datas exatas, mas com interesse nao definido.",
  4: "Periodo de proprietario com datas aproximadas, mas com interesse nao definido.",
  5: "Postagem com datas exatas e mesmo tipo de interesse.",
  6: "Postagem com datas aproximadas e mesmo tipo de interesse.",
  7: "Periodo de proprietario com datas exatas, mas com interesse invertido.",
  8: "Postagem com datas exatas, mas com interesse invertido.",
  9: "Periodo de proprietario com datas menos aproximadas e mesmo tipo de interesse.",
};
